import axios from 'axios';
import Cookies from "js-cookie";
import { safeParseJson } from "../utils/auth";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const uploadApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL_UPLOAD,
});

api.interceptors.request.use(
    (config) => {
        const userData = Cookies.get('userData');
        const userDataString = safeParseJson(userData, null);
        if (userDataString?.token) {
            config.headers.Authorization = `Bearer ${userDataString.token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export { api, uploadApi };